import * as firebase from 'firebase';

firebase.initializeApp({
  apiKey: "AIzaSyCvxNCRNOXRd7l5DrsDvh67Hak7HlW2AWY",
  authDomain: "app.refresh.works",
  databaseURL: "https://refresh-1cbbe-default-rtdb.firebaseio.com",
  projectId: "refresh-1cbbe",
  storageBucket: "refresh-1cbbe.appspot.com",
  messagingSenderId: "199207288137",
  appId: "1:199207288137:web:d6e98082d639c350f3ae98",
  measurementId: "G-4F9G155C9Y"
});
export const authRef = firebase.auth();



// WEBPACK FOOTER //
// ./src/reference.js